
import { defineComponent, PropType, ref, computed } from "vue";
import { Choice, QuestionForm } from "../../../../domain/entities/search-form/question_form";
import TUIViewer from "../../components/application/TUIViewer.vue";

export default defineComponent({
  name: "QuestionFormMoreAnswer",
  components: { TUIViewer },
  props: {
    question: {
      type: Object as PropType<{ question: QuestionForm }>,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const selectedCheckboxes = ref<number[]>(
      props.question.question.multiAnswerIds || []
    );

    const checkboxOptions = computed(() =>
      (props.question.question.multiChoices || []).map((choice: Choice) => ({
        value: choice.id,
        label: choice.answerText
      }))
    );

    function getMultiAnswers() {
      return selectedCheckboxes.value;
    }

    return {
      selectedCheckboxes,
      checkboxOptions,
      getMultiAnswers
    };
  }
});
